import {Component} from '@angular/core';

@Component({
  selector: 'hangup-node',
  templateUrl: './hangup-node.component.html'
})
export class HangupNodeComponent {
    node
}
